module.exports = __webpack_public_path__ + "img/Y2401.bbe3cf02.jpeg";